import { createFileRoute } from "@tanstack/react-router";
import Success from "@/components/_Success";

export const Route = createFileRoute("/_auth/docs_/$documentId/success")({
  component: Success,
});
